export enum FlowType {
  boondock = 'boondock',
  guest = 'guest',
  listing = 'listing',
  sales = 'sales',
}
